import React from "react";
import DiaglogBox from "../DiaglogBox";

const AddMoreRequest = ({open, onCancel}) => {

  return (
    <div>
      <DiaglogBox width={617} open={open} onCancel={onCancel}>
        <div className="py-20 text-center text-xl font-semibold">
          Request Seller to inquire more credits
        </div>
      </DiaglogBox>
    </div>
  );
};

export default AddMoreRequest;
